import { Controller } from 'stimulus'
import { trackEvent } from '../../src/javascripts/tracking'

export default class extends Controller {
  static targets = ['participantCount', 'submit', 'minParticipantMsg', 'onsiteHostFromSpan', 'breakdownContainer', 'breakdownInfo']
  static values = { baseUrl: String, priceStructures: Array, themeName: String, isCore: Boolean }

  static ONSITE_HOST_FACILITATOR_COST = 750
  static HOSTING_TYPE_ONSITE = "On-Site Host"
  static HOSTING_TYPE_REMOTE = "Remote Host"
  static HOSTING_TYPE_SELF_MANAGED = "Self-Managed"

  trackedFields(currencyCode, quote) {
    return {
      'participants': this.participantCount,
      'currency': currencyCode,
      'price': quote,
      'themeName': this.themeNameValue
    }
  }

  connect() {
    window.feather.replace()
    this.realField = $(`#${this.data.get('realId')}`)
    this.participantCount = 0
    this.facilitatorRequired = this.usesFacilitator()
    this.calculateQuote(false)
    this.createUrl()

    trackEvent('Visited Product Page', {
      'themeName': this.themeNameValue
    });
  }

  countParticipants(e) {
    this.validateInputs(e)
    this.calculateQuote(true)
  }

  increaseParticipants(e) {
    var currentCount = parseInt($(this.participantCountTarget).val())
    $(this.participantCountTarget).val(currentCount + 1)
    if (isNaN(currentCount)) { $(this.participantCountTarget).val(0) }
    this.countParticipants($(this.participantCountTarget))
    if (this.participantCount > 0) {
      this.minParticipantMsgTarget.classList.add('hidden')
      if (this.isOnsiteHost()) this.onsiteHostFromSpanTarget.classList.remove('hidden')
    }
  }

  decreaseParticipants(e) {
    var currentCount = parseInt($(this.participantCountTarget).val())
    $(this.participantCountTarget).val(currentCount - 1)
    if (isNaN(currentCount)) { $(this.participantCountTarget).val(1) }
    this.countParticipants($(this.participantCountTarget))
    if (this.participantCount > 0) {
      this.minParticipantMsgTarget.classList.add('hidden')
      if (this.isOnsiteHost()) this.onsiteHostFromSpanTarget.classList.remove('hidden')
    }
  }

  validateInputs(e) {
    let input = e.target

    if (e.target == undefined) {
      input = e[0]
    }

    var min = input.getAttribute('min')
    if (!!min && input.value && input.value < parseFloat(min)) {
      input.value = min
    }

    var max = input.getAttribute('max')
    if (!!max && input.value && input.value > parseFloat(max)) {
      input.value = max
    }
  }

  usesFacilitator() {
    return $('#facilitator-checkbox').is(':checked') ? 1 : 0
  }

  checkbox(e) {
    const value = $(e.currentTarget).is(':checked')
    this.realField.prop('checked', value)
    this.calculateQuote(false)
  }

  currencySelectChange(event) {
    if ($('#select-currency option:contains(GBP)').is(':selected')) {
      $('#VAT').text('*excludes 20% VAT')
    }
    else {
      $('#VAT').text('')
    }

    trackEvent('dropdown_select', {
      'currency': event.target.value,
      'element_name': 'calculator_widget_currency_select',
      'element_content': ['text'],
      'element_action': 'select'
    })

    this.calculateQuote(false)
  }

  hostSelectChange(event) {
    const isOnSiteHost = this.isOnsiteHost()

    this.onsiteHostFromSpanTarget.classList.toggle('hidden', !isOnSiteHost || this.participantCount === 0)
    $('#check-availability').toggleClass('hidden', isOnSiteHost)
    $('#enquire-now').toggleClass('hidden', !isOnSiteHost)

    trackEvent('dropdown_select', {
      'host': event.target.value,
      'element_name': 'calculator_widget_host_select',
      'element_content': ['text'],
      'element_action': 'select'
    })

    this.calculateQuote()
  }

  updateBreakdown() {
    this.priceStructuresValue.forEach(countryData => {
      if ($('#select-currency option:contains(' + countryData["currencyCode"] + ')').is(':selected')) {
        const individualParticipantCost = this.calculateIndividualParticipantCost(countryData)
        const totalMinimumCost = this.calculateMinimumCost(0, countryData)
        const availableParticipants = totalMinimumCost / countryData["perParticipantCost"]

        let host = ''

        switch (this.getHostingType()) {
          case this.constructor.HOSTING_TYPE_ONSITE:
            host = 'on-site'
            break
          case this.constructor.HOSTING_TYPE_SELF_MANAGED:
            host = 'self-managed'
            break
          default:
            host = 'remote'
        }

        if (this.participantCount <= 0) {
          this.breakdownContainerTarget.classList.add('hidden')
          return
        }

        this.breakdownContainerTarget.classList.remove('hidden')

        if (host === 'self-managed') {
          this.breakdownInfoTarget.innerHTML = `
            <p class="font-bold font-sm">Your self-managed event based on ${countryData["symbol"]}${countryData["perParticipantCost"]} per person</p>
          `
        }
        else if (totalMinimumCost > 0) {
          const minimumCostLeft = totalMinimumCost - individualParticipantCost
          const participantsLeft = Math.ceil(minimumCostLeft / countryData["perParticipantCost"])
          const leftOverParticipants = participantsLeft == 1 ? '1 more participant' : `${participantsLeft} more participants`

          if (participantsLeft <= 0) {
            this.breakdownInfoTarget.innerHTML = `
              <p class="font-bold font-sm">Your ${host} hosted event for ${countryData["symbol"]}${countryData["perParticipantCost"]} per person</p>
              <p class="text-xs font-normal">Minimum spend: <span class="font-bold">${countryData["symbol"]}${totalMinimumCost} (includes ${host} host and ${availableParticipants} participants)</span></p>
              <p class="text-xs font-normal">Additional participants: <span class="font-bold">${countryData["symbol"]}${countryData["perParticipantCost"]} each</span></p>
            `
          } else {
            this.breakdownInfoTarget.innerHTML = `
              <p class="font-bold font-sm">Add ${leftOverParticipants} for no additional cost!</p>
              <p class="text-xs font-normal">Minimum spend: <span class="font-bold">${countryData["symbol"]}${totalMinimumCost} (includes ${host} host and ${availableParticipants} participants)</span></p>
            `
          }
        } else {
          this.breakdownInfoTarget.innerHTML = `
            <p class="font-bold font-sm">Your ${host} hosted event for ${countryData["symbol"]}${countryData["perParticipantCost"]} per person</p>
            <p class="text-xs font-normal">Includes: <span class="font-bold">${host} host for ${countryData["symbol"]}${this.calculateFacilitatorCost(countryData)}</span></p>
          `
        }
      }
    })
  }

  calculateQuote(trackMixpanel) {
    var currencyCode = ""
    var quote = ""

    this.priceStructuresValue.forEach(countryData => {
      quote = this.calculateParticipantsCost(countryData)
      if (quote > 0) quote += this.calculateFacilitatorCost(countryData)
      if (this.participantCount > 0) quote += this.calculateMinimumCost(quote, countryData)
      currencyCode = countryData["currencyCode"]

      this.displayQuote(countryData, quote)
      this.toggleSubmit(quote)
    })

    if (this.hasBreakdownInfoTarget) {
      this.updateBreakdown()
    }

    if (trackMixpanel == true) {
      trackEvent('Widget: Updated Participants', this.trackedFields(currencyCode, quote));
    }

    this.createUrl()
  }

  toggleSubmit(quote) {
    $(this.submitTarget).toggleClass('opacity-40', quote == 0)
  }

  displayQuote(countryData, quote) {
    if (this.isCoreValue == true) {
      $('#select-currency option:contains('+ countryData["currencyCode"] +')').text(`${countryData["symbol"]}${quote} ${countryData["currencyCode"]}`);
    } else {
      $('#partner-quote').text(`${countryData["symbol"]}${quote} ${countryData["currencyCode"]}`)
    };
  }

  calculateMinimumCost(quote, countryData) {
    let quoteIncrease = 0

    const onSiteHostCost = this.calculateOnSiteHostCost(countryData)

    if (quote < onSiteHostCost) {
      quoteIncrease += onSiteHostCost
    }
    else if ((countryData["hasReducedPrice"] == true) && (quote < countryData["minimumCost"])) {
      quoteIncrease += countryData["minimumCost"]
    }

    return quoteIncrease
  }

  calculateOnSiteHostCost(countryData) {
    if (this.isOnsiteHost()) {
      return countryData["minimumOnsiteHostCost"]
    }
    else {
      return 0
    }
  }

  isOnsiteHost() {
    return this.getHostingType() == this.constructor.HOSTING_TYPE_ONSITE
  }

  calculateIndividualParticipantCost(countryData) {
    this.participantCount = parseInt($('#attendees-count').val())
    return countryData["perParticipantCost"] * this.participantCount
  }

  calculateParticipantsCost(countryData) {
    const participantsCost = this.calculateIndividualParticipantCost(countryData)
    const totalOnsiteCost = participantsCost + this.calculateFacilitatorCost(countryData)

    if (participantsCost < countryData["minimumCost"] || totalOnsiteCost < this.calculateOnSiteHostCost(countryData) || isNaN(participantsCost)) {
      return 0
    }
    else {
      return participantsCost
    }
  }

  getHostingType() {
    return $('#select-host').find(":selected").val();
  }

  calculateFacilitatorCost(countryData) {
    let host = this.getHostingType();
    this.facilitatorRequired = this.usesFacilitator()

    if (host == this.constructor.HOSTING_TYPE_REMOTE || this.facilitatorRequired == 1) {
      return countryData["facilitatorCost"]
    }
    else if (host == this.constructor.HOSTING_TYPE_ONSITE) {
      return this.constructor.ONSITE_HOST_FACILITATOR_COST
    }
    else {
      return 0
    }
  }

  createUrl() {
    let currency = "GBP"
    let facilitatorRequired = 0
    if (this.getHostingType() === this.constructor.HOSTING_TYPE_REMOTE || this.facilitatorRequired === 1) {
      facilitatorRequired = 1
    }
    if (this.isCoreValue == true) {
      let selectWords = $('#select-currency option:selected').text().split(' ');
      currency = selectWords[1]
      this.url = `${this.baseUrlValue}&participants=${this.participantCount}&host=${facilitatorRequired}&currency=${currency}`
    } else {
      this.url = `${this.baseUrlValue}&participants=${this.participantCount}&host=${facilitatorRequired}`
    }
  }

  createOrder(e) {
    e.preventDefault()
    if (this.participantCount > 0) {
      this.minParticipantMsgTarget.classList.add('hidden')
      var currencyCode = ""
      var quote = ""

      this.createUrl()

      this.priceStructuresValue.forEach(countryData => {
        if ($('#select-currency option:contains(' + countryData["currencyCode"] + ')').is(':selected')) {
          quote = this.calculateParticipantsCost(countryData)
          quote += this.calculateFacilitatorCost(countryData)
          quote += this.calculateMinimumCost(quote, countryData)
          currencyCode = countryData["currencyCode"]
        }
      })

      trackEvent('Check Availability', this.trackedFields(currencyCode, quote));

      window.location.href = this.url
      return true
    } else {
      this.minParticipantMsgTarget.classList.remove('hidden')
      return false
    }
  }
}